import * as React from "react";

export default function LoadingOverlay() {
  return (
    <React.Fragment>
      <div id="ap-loading-overlay">
        <div id="ap-loading-image"></div>
      </div>
    </React.Fragment>
  );
}
